// src/context/PanierContext.jsx
import React, { createContext, useEffect, useMemo, useState } from 'react';

export const PanierContext = createContext();

export const PanierProvider = ({ children }) => {
  const [panier, setPanier] = useState(() => {
    try {
      const saved = localStorage.getItem('panier');
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem('panier', JSON.stringify(panier));
  }, [panier]);

  // ✅ garde l’ID unique complet et la quantité envoyée
  const normalize = (p) => ({
    id: p.id, // ex: `${product.id}-${product.vendeur_id}`
    nom: p.nom ?? p.titre ?? p.description ?? 'Produit',
    unite: p.unite ?? p.unit ?? 'kg',
    prix: Number(p.prix ?? p.price ?? 0),
    quantite: Math.max(1, Number(p.quantite ?? 1)), // conserve la quantité donnée
    image: p.image ?? p.img ?? null,
  });

  const ajouterAuPanier = (produit) => {
    const item = normalize(produit);
    if (!item.id || item.prix <= 0) return;

    setPanier((prev) => {
      const idx = prev.findIndex((it) => it.id === item.id);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = {
          ...next[idx],
          quantite: Number(next[idx].quantite) + Number(item.quantite),
        };
        return next;
      }
      return [...prev, item];
    });
  };

  const modifierQuantite = (idProduit, nouvelleQuantite) => {
    const q = Math.max(1, Number(nouvelleQuantite) || 1);
    setPanier((prev) =>
      prev.map((item) =>
        item.id === idProduit ? { ...item, quantite: q } : item
      )
    );
  };

  const supprimerProduit = (id) =>
    setPanier((prev) => prev.filter((item) => item.id !== id));

  const viderPanier = () => {
    setPanier([]);
    localStorage.removeItem('panier');
  };

  const total = useMemo(
    () =>
      panier.reduce(
        (acc, it) => acc + (Number(it.prix) || 0) * (Number(it.quantite) || 0),
        0
      ),
    [panier]
  );

  return (
    <PanierContext.Provider
      value={{
        panier,
        total,
        ajouterAuPanier,
        supprimerProduit,
        modifierQuantite,
        viderPanier,
      }}
    >
      {children}
    </PanierContext.Provider>
  );
};
